module.exports = __webpack_public_path__ + "img/manufacturing_zhoushan.7a15cb1d.png";